
import { ShipBranchWarehousesResult } from "@gtsanders/Services/ShipmentBranchWarehouseService";
import ShipmentBranchWarehousesState, { ShipBranchWarehouses } from "@gtsanders/Store/Pages/CheckoutReviewAndSubmit/ShipmentBranchWarehousesState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Cart } from "@insite/client-framework/Services/CartService";
import CartState from "@insite/client-framework/Store/Pages/Cart/CartState";
import { CartModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: ShipmentBranchWarehousesState = {
    shipmentBranchWarehouses: [],
    isLoading: false,
    shipBranchWarehousesLoaded: false,
    selectedWarehouse: {
        SelectedWarehouse: "",
        SelectedWarehouseDesc: ""
    }
};
export interface SelectedWarehouse {
    SelectedWarehouse: string;
    SelectedWarehouseDesc: string;
}

const reducer =  {
       "Custom/CheckoutReviewAndSubmit/BeginLoadShipBranchWarehouses":
         (
            draft: Draft<ShipmentBranchWarehousesState>
        ) => {
            draft.isLoading = true;
        },
        "Custom/CheckoutReviewAndSubmit/CompleteLoadShipBranchWarehouses":
         (
            draft: Draft<ShipmentBranchWarehousesState>,
            action: { result: ShipBranchWarehousesResult }
        ) => {
            draft.shipmentBranchWarehouses = action.result.apiResult as ShipBranchWarehouses[];
            draft.shipBranchWarehousesLoaded = true;
        },
        "Custom/CheckoutReviewAndSubmit/CleanupShipBranchWarehousesData":(draft: Draft<ShipmentBranchWarehousesState>,) => {
            draft.isLoading = false;
        }
};


export default createTypedReducerWithImmer(initialState, reducer);
